import * as z from "zod/v4";
import {
  LogicalQueryCastTypeSchema,
  type LogicalQueryTableName,
} from "./logical-query-primitives";

export const trimStringInput = (value: unknown) =>
  typeof value === "string" ? value.trim() : value;

const RawLogicalQueryIdentifierSchema = z
  .string()
  // Keep identifiers to ordinary compiler-safe names. User-facing labels use
  // LogicalQueryNameSchema below and are quoted separately by the Snowflake compiler.
  .regex(/^[a-zA-Z_][a-zA-Z0-9_]*$/)
  .max(64);

export const LogicalQueryIdentifierSchema = z.preprocess(
  trimStringInput,
  RawLogicalQueryIdentifierSchema,
);

export const LogicalQueryNameSchema = z.string().min(1).max(120);

export const TrimmedLogicalQueryCastTypeSchema = z.preprocess(
  trimStringInput,
  LogicalQueryCastTypeSchema,
);

export const DefaultTableAliases: Record<LogicalQueryTableName, string> = {
  orders: "ord",
  order_customer_classifications: "occ",
  return_facts: "rf",
  return_compensation_methods: "rcm",
  return_order_facts: "rof",
  return_order_line_items: "roli",
  merchant_line_items: "mli",
  order_product_reports: "opr",
  return_line_items: "rli",
  return_product_reports: "rpr",
  returns: "ret",
  return_reports: "rr",
};

export const LogicalAggregateFnSchema = z.enum([
  "count",
  "count_distinct",
  "count_if",
  "sum",
  "avg",
  "min",
  "max",
  "any_value",
]);

export const LogicalQuerySourceModeSchema = z.enum([
  "report_tables",
  "raw_tables",
]);

export type LogicalQuerySourceMode = z.infer<
  typeof LogicalQuerySourceModeSchema
>;

export const DEFAULT_LOGICAL_QUERY_SOURCE_MODE: LogicalQuerySourceMode =
  "report_tables";

export const LOGICAL_QUERY_FINAL_OUTPUT_LIMIT = 25;
export const LOGICAL_QUERY_SORT_LIMIT = 5;
export const LOGICAL_QUERY_ROW_LIMIT_MAX = 2000;
